// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioButton__radio-db2ef8 {
  visibility: hidden;
  width: 0;
  height: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/RadioButton/RadioButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AACF","sourcesContent":[".radio {\n  visibility: hidden;\n  width: 0;\n  height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radio": `RadioButton__radio-db2ef8`
};
module.exports = ___CSS_LOADER_EXPORT___;
